module.exports = __webpack_public_path__ + "static/media/C20-0733_COVID-19_FR_Desktop_2396x1473.eb40b083.jpg";